import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  position: relative;
  min-height: 85vh;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const BgImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('/images/barney.jpg');
  background-size: cover;
  background-position: center 30%;
  background-attachment: fixed;

  @media (max-width: 768px) {
    background-attachment: scroll;
    background-position: center 40%;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(40, 20, 10, 0.15) 0%,
    rgba(40, 20, 10, 0.1) 50%,
    rgba(40, 20, 10, 0.7) 100%
  );
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 60px 20px 80px;
  max-width: 700px;
`;

const Label = styled.div`
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: rgba(245, 222, 179, 0.7);
  margin-bottom: 12px;
  text-shadow: 0 2px 8px rgba(0,0,0,0.4);
`;

const Title = styled.h2`
  font-size: clamp(3.5rem, 8vw, 6rem);
  color: var(--wheat);
  margin-bottom: 8px;
  text-shadow: 0 4px 20px rgba(0,0,0,0.4);
`;

const Subtitle = styled.div`
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.2rem, 3vw, 1.6rem);
  color: var(--wheat);
  font-style: italic;
  opacity: 0.9;
  margin-bottom: 25px;
  text-shadow: 0 2px 10px rgba(0,0,0,0.4);
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: rgba(245, 222, 179, 0.85);
  line-height: 1.8;
  text-shadow: 0 1px 6px rgba(0,0,0,0.4);
`;

export default function Greeter() {
  return (
    <Section id="greeter">
      <BgImage />
      <Overlay />

      <Content>
        <Label>Meet Our Official Greeter</Label>
        <Title>Barney</Title>
        <Subtitle>Our Official Greeter</Subtitle>
        <Description>
          Every visit to Red Barn Gardens starts with a warm welcome from
          Barney — always ready with a wagging tail and plenty of love to share.
        </Description>
      </Content>
    </Section>
  );
}
